import {ImageSourceSetDto} from './DestinationImagesModel';

export interface ListingResponse<T> {
    data: T[];
    total: number;
}

export enum ExperienceSort {
    Featured = 'featured',
    PriceLow = 'price_low',
    PriceHigh = 'price_high',
    TopRated = 'top_rated'
}

export enum ExperienceCategory {
    Tours = 'tours',
    DayTrips = 'day_trips',
    OnTheWater = 'on_the_water',
    FoodAndDrink = 'food_and_drink',
    Outdoor = 'outdoor',
    Shows = 'shows'
}

export enum ExperienceDurationRange {
    UpToOneHour = 'up_to_one_hour',
    OneToFourHours = 'one_to_four_hours',
    FourHoursToOneDay = 'four_hours_to_one_day'
}

export enum ExperienceBadge {
    SpecialOffer = 'special_offer',
    LikelyToSellOut = 'likely_to_sell_out'
}

export interface ExperienceDurationDto {
    minMinutes: number;
    maxMinutes: number;
}

export interface ExperienceCardDto {
    productCode: string;
    title: string;
    imageUrl: string | null;
    rating: number | null;
    reviewCount: number;
    duration: ExperienceDurationDto | null;
    fromPriceUsd: number;
    memberPriceUsd: number;
    hasFreeCancellation: boolean;
    badge: ExperienceBadge | null;
    productUrl: string;
}

export interface MemberDiscount {
    hasMemberDiscount: boolean;
    memberDiscountCode: string | null;
}

export interface ExperienceSearchResultDto extends ListingResponse<ExperienceCardDto>, MemberDiscount {
    datesApplied: boolean;
}

export enum ExperienceHomeSource {
    Location = 'location',
    HomeAirport = 'home_airport'
}

export enum ExperienceTrackingSource {
    Landing = 'landing',
    Results = 'results',
    Experiences = 'experiences',
    BookingModal = 'booking_modal',
    Deal = 'deal'
}

export interface ExperienceHomeDto {
    source: ExperienceHomeSource;
    airportIata: string | null;
    cityName: string;
    viatorDestinationId: number;
}

export interface ExperienceDestinationOptionDto {
    viatorDestinationId: number;
    name: string;
    experienceCount: number | null;
}

export interface ExperienceDestinationTileDto extends ExperienceDestinationOptionDto {
    coverImage: ImageSourceSetDto | null;
}

export interface ExperienceLandingDto extends MemberDiscount {
    home: ExperienceHomeDto | null;
    topExperiences: ExperienceCardDto[];
    nearbyDestinations: ExperienceDestinationOptionDto[];
    popularDestinations: ExperienceDestinationTileDto[];
}

export interface ExperienceFilter {
    minRating: number | null;
    duration: ExperienceDurationRange | null;
    hasFreeCancellation: boolean;
    hasSpecialOffer: boolean;
    isLikelyToSellOut: boolean;
}

export interface ExperienceSearchTarget {
    viatorDestinationId: number;
    destinationName: string;
}

export interface ExperienceSearch extends ExperienceSearchTarget {
    sort: ExperienceSort;
    category: ExperienceCategory | null;
    filters: ExperienceFilter;
}

export interface ExperienceBookingModalData {
    experience: ExperienceCardDto;
    memberDiscount: MemberDiscount;
}

export enum ExperienceDestinationList {
    Recent = 'recent',
    Nearby = 'nearby',
    Matches = 'matches'
}
